import { ISite } from '@/Core.Service.Domain/Sites/Sites.Common/types/site.ts';
import { IEgaugeRegister } from '@/Core.Service.Domain/Monitors/Egauges/types/register';
import { IEgauge } from '@/Core.Service.Domain/Monitors/Egauges/types/egauge.ts';
import { IUnmappedRegisters } from '@/Core.Service.Domain/Monitors/Egauges/types/unmappedRegisters.ts';

const getSelectedSite = (state: { selectedSite: ISite }) => state.selectedSite;

const getRegistersList = (state: { registersList: IEgaugeRegister[] }) =>
  state.registersList;

const getEgaugeInfo = (state: { egaugeInfo: IEgauge }) => state.egaugeInfo;

const getUnmappedRegister = (state: {
  unmappedRegisters: IUnmappedRegisters;
}) => state.unmappedRegisters;

export default {
  getSelectedSite,
  getRegistersList,
  getEgaugeInfo,
  getUnmappedRegister,
};
